import React from 'react';
import TitleWithBar from 'components/TitleWithBar';
import style from './style.scss';

const Ingredients = ({product}) => {
    return (
        <div className="product-ingredients">
            <TitleWithBar title="Ingredientes" />
            <div className="product-ingredients-text">{product.Ingredientes}</div>
        </div>
    )
}

export default Ingredients;